export default {
  title: {
    text: "全球电子特气企业",
    left: "center",

    textStyle: {},
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b} : {c} ({d}%)",
  },

  series: [
    {
      name: "占比",
      type: "pie",
      radius: "50%",
      center: ["50%", "50%"],
      data: [
        { value: 18, name: "美国普莱克斯" },
        { value: 18, name: "日本太阳日酸" },
        { value: 8, name: "德国林德" },
        { value: 24, name: "法国液化空气" },
        { value: 26, name: "美国气体化工" },
        { value: 6, name: "其他" },
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)",
        },
      },
    },
  ],
};
